/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';

import Localized from '../../../shared/components/Localized';
import Modal, { ModalHeader, ModalFooter } from '../../components/Modal';
import Button from '../../components/Button';
import { Select } from '../../components/Form';

const ModalBody = styled.div`
  padding: 2rem;
`;

const timezoneOptions = moment.tz.names()
                                 .sort((a, b) => moment().tz(a).utcOffset() - moment().tz(b).utcOffset())
                                 .map((timezone) => ({
                                   value: timezone,
                                   text: `(UTC ${moment().tz(timezone).format('Z')}) ${timezone}`
                                 }));


export default class TimezonePickerModal extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      value: props.timezone,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
    this.useMyLocalTimezone = this.useMyLocalTimezone.bind(this);
  }

  handleChange(event){
    this.setState({ value: event.target.value });
  }

  submit() {
    this.props.changeTimezone(this.state.value);
    this.props.onClose();
  }

  useMyLocalTimezone() {
    this.props.changeTimezone(moment.tz.guess());
    this.props.onClose();
  }

  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader text={ <Localized modelName='timezonePicker' modelAttribute='header' modelKey='selectTimezone' /> } />
        <ModalBody>
          <Button theme='brand' onClick={this.useMyLocalTimezone}><Localized modelName='timezonePicker' modelAttribute='button' modelKey='useMyTimezone' /></Button>
          <br /><br /><Localized modelName='timezonePicker' modelAttribute='label' modelKey='or' /><br /><br />
          <Select options={timezoneOptions} onChange={this.handleChange} value={this.state.value}/>
        </ModalBody>

        <ModalFooter>
          <Button onClick={this.props.onClose}><Localized modelName='modalFooter' modelAttribute='label' modelKey='Close' /></Button>
          <Button theme='brand' onClick={this.submit}><Localized modelName='modalFooter' modelAttribute='label' modelKey='Submit' /></Button>
        </ModalFooter>
      </Modal>
    );
  }
}
